import TemplateChecklistComponent from './TemplateChecklistComponent';

export default TemplateChecklistComponent;
